/*
 * Copyright © 2018-2020, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import { ApiPromise } from "../models/ApiPromise";
import { axiosCommon } from "../util/axiosSetup";
import { Void } from "../models/Void";
import Params from "../common/Params";
import { BillingSystemConfigResponse } from "../models/management/BillingSystemConfigResponse";
import { BillingSystemConfigRequest } from "../models/management/BillingSystemConfigRequest";
import { FortnoxIntegrationRequest } from "../models/clinic/FortnoxIntegrationRequest";

export default class BillingSystemConfigApi {
  private static baseUrl = Params.clinicServiceBaseURL;

  static getConfig(
    countryCode: string
  ): ApiPromise<BillingSystemConfigResponse> {
    const url = `${this.baseUrl}/managements/countries/${countryCode}/billing-systems`;
    return axiosCommon.get(url);
  }

  static updateConfig(
    countryCode: string,
    request: BillingSystemConfigRequest
  ): ApiPromise<BillingSystemConfigResponse> {
    const url = `${this.baseUrl}/managements/countries/${countryCode}/billing-systems`;
    return axiosCommon.put(url, request);
  }

  static deleteConfig(countryCode: string): ApiPromise<Void> {
    const url = `${this.baseUrl}/managements/countries/${countryCode}/billing-systems`;
    return axiosCommon.delete(url);
  }

  static addFortnoxIntegration(
    countryCode: string,
    request: FortnoxIntegrationRequest
  ): ApiPromise<void> {
    const url = `${this.baseUrl}/managements/countries/${countryCode}/billing-systems/fortnox-integration`;
    return axiosCommon.put(url, request);
  }
}
